import React from 'react';
import styled from 'styled-components';
import { Link, useLocation } from 'react-router-dom';
import SubBanner from './SubBanner';

const MainWrapper = styled.div`
  background: #f5f5f5;
  padding: 50px 0;

  @media (max-width: 768px) {
    padding: 30px 0;
  }
`;

const LayoutContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  background: white;
  box-shadow: 0 0 20px rgba(0,0,0,0.05);

  @media (max-width: 1024px) {
    flex-direction: column;
  }
`;

const Sidebar = styled.aside`
  width: 250px;
  border-right: 1px solid #eee;
  flex-shrink: 0;

  @media (max-width: 1024px) {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid #eee;
  }
`;

const SidebarTitle = styled.div`
  background: #1a2a40;
  color: white;
  padding: 40px 20px;
  h3 { font-size: 1.8rem; margin: 0; }
  p { font-size: 0.9rem; opacity: 0.6; margin: 5px 0 0; }

  @media (max-width: 1024px) {
    padding: 25px 20px;
    h3 { font-size: 1.4rem; }
  }
`;

const MenuList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;

  @media (max-width: 1024px) {
    display: flex;
    flex-wrap: wrap;
  }
`;

const MenuItem = styled(Link)`
  display: block;
  padding: 20px;
  border-bottom: 1px solid #eee;
  text-decoration: none;
  font-size: 1rem;
  color: ${props => props.$active ? '#0056b3' : '#666'};
  font-weight: ${props => props.$active ? '700' : '400'};
  background: ${props => props.$active ? '#fcfcfc' : 'white'};
  &:hover { background: #f9f9f9; }

  @media (max-width: 1024px) {
    flex: 1;
    text-align: center;
    border-bottom: none;
    border-right: 1px solid #eee;
    padding: 15px 10px;
    font-size: 0.9rem;
    &:last-child { border-right: none; }
  }
`;

const ContentArea = styled.main`
  flex: 1;
  padding: 60px 50px;
  min-width: 0;

  @media (max-width: 768px) {
    padding: 30px 20px;
  }
`;

const ContentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  border-bottom: 2px solid #333;
  padding-bottom: 15px;
  margin-bottom: 40px;
  h2 { font-size: 2rem; margin: 0; color: #333; }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    h2 { font-size: 1.5rem; }
  }
`;

const Breadcrumb = styled.div`
  font-size: 0.85rem;
  color: #888;
  white-space: nowrap;
  strong { color: #333; font-weight: 500; }
  span.separator { margin: 0 8px; color: #ccc; }
`;

const SubLayout = ({ title, sidebarMenus, category = '회사소개', categoryEn = 'About Company', bannerBg, activePath, children }) => {
  const location = useLocation();
  // 상세 페이지(예: /notices/3)에서는 목록 경로를 activePath로 넘겨 부모 메뉴를 활성 표시한다
  const currentPath = activePath || location.pathname;

  return (
    <>
      <SubBanner bg={bannerBg} />
      <MainWrapper>
        <LayoutContainer>
          <Sidebar>
            <SidebarTitle>
              <h3>{category}</h3>
              <p>{categoryEn}</p>
            </SidebarTitle>
            <MenuList>
              {sidebarMenus.map((menu, index) => (
                <li key={index}>
                  <MenuItem
                    to={menu.path}
                    $active={currentPath === menu.path}
                  >
                    {menu.label}
                  </MenuItem>
                </li>
              ))}
            </MenuList>
          </Sidebar>

          <ContentArea>
            <ContentHeader>
              <h2>{title}</h2>
              <Breadcrumb>
                홈 <span className="separator">&gt;</span>
                {category} <span className="separator">&gt;</span>
                <strong>{title}</strong>
              </Breadcrumb>
            </ContentHeader>
            {children}
          </ContentArea>
        </LayoutContainer>
      </MainWrapper>
    </>
  );
};

export default SubLayout;
